import React from 'react';
import './Expertise.css';

const Expertise = () => {
  const scrollToContact = () => {
    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="expertise" className="expertise-section">
      <h2 className="expertise-title">My Expertise</h2>
      <div className="expertise-content">
        <div className="expertise-about">
          <h3>Who I Am</h3>
          <p>
            I am a software engineer and game developer with a passion for creating engaging and user-friendly applications. 
          </p>
          <p>
            My experience spans across various programming languages, frameworks, and tools, allowing me to design and develop innovative solutions.
          </p>
          <p>
            I thrive in collaborative environments and am always eager to learn and grow in the field of technology.
          </p>
          <button className="scroll-to-contact" onClick={scrollToContact}>
            Contact Me
          </button>
        </div>
        <div className="expertise-skills">
          <h3>My Skills</h3>
          <div className="skills-list">
            {[
              'Java', 'C', 'C#', 'SQL', 'Python',
              'HTML', 'CSS', 'JavaScript', 'Assembly',
              'Git', 'React', 'Node.js', 'Postman', 'Jenkins',
              'Jira', 'UML Design', 'MySQL', 'SQuirreL',
              'Godot', 'Unity', 'UI/UX Design'
            ].map((skill, index) => (
              <span key={index} className="skill-item">
                {skill}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Expertise;

